import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "edit_account_setting_modal",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "editAccountSettingModalRef"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "edit_account_setting_modal_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_7 = {
  class: "scroll-y me-n7 pe-7",
  id: "edit_account_setting_modal_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#edit_account_setting_modal_header",
  "data-kt-scroll-wrappers": "#edit_account_setting_modal_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_8 = { class: "fv-row mb-7" }
const _hoisted_9 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "fv-row mb-7" }
const _hoisted_13 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_14 = { class: "fv-plugins-message-container" }
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = { class: "fv-row mb-7" }
const _hoisted_17 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_18 = { class: "fv-plugins-message-container" }
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "fv-row mb-7" }
const _hoisted_21 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_22 = { class: "fv-plugins-message-container" }
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = { class: "modal-footer flex-end" }
const _hoisted_25 = ["data-kt-indicator"]
const _hoisted_26 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_27 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_28 = {
  key: 1,
  class: "indicator-progress"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.translate("EDIT_ACCOUNT_SETTINGS_MODAL_TITLE")), 1)
        ]),
        (_ctx.currentCustomer)
          ? (_openBlock(), _createBlock(_component_Form, {
              key: 0,
              id: "kt_change_password",
              class: "form",
              novalidate: "novalidate",
              onSubmit: _ctx.submit,
              "validation-schema": _ctx.editAccountSettingSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.translate("CHANGE_USERNAME_NEW_LABEL")), 1),
                      _createVNode(_component_Field, {
                        class: "form-control form-control-lg fw-bold fs-6",
                        name: "user_name",
                        modelValue: _ctx.currentCustomer.user_name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentCustomer.user_name) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_ErrorMessage, { name: "user_name" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate("CHANGE_EMAIL_NEW_LABEL")), 1),
                      _createVNode(_component_Field, {
                        class: "form-control form-control-lg fw-bold fs-6",
                        name: "email",
                        modelValue: _ctx.currentCustomer.email,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentCustomer.email) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_ErrorMessage, { name: "email" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("label", _hoisted_17, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.translate("CHANGE_ROLE_NEW_LABEL")), 1)
                      ]),
                      _createVNode(_component_Field, {
                        class: "form-control form-control-lg fw-bold fs-6",
                        name: "ruolo_aziendale",
                        modelValue: _ctx.currentCustomer.ruolo_aziendale,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentCustomer.ruolo_aziendale) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_ErrorMessage, { name: "ruolo_aziendale" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.translate("CHANGE_MOBILE_NEW_LABEL")), 1),
                      _createVNode(_component_Field, {
                        class: "form-control form-control-lg fw-bold fs-6",
                        name: "telefono",
                        modelValue: _ctx.currentCustomer.telefono,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentCustomer.telefono) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_ErrorMessage, { name: "telefono" })
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("button", {
                    type: "button",
                    id: "edit_account_setting_modal_cancel",
                    class: "btn btn-white",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, _toDisplayString(_ctx.translate("BUTTON_CLOSE")), 1),
                  _createElementVNode("button", {
                    "data-kt-indicator": _ctx.loading ? 'on' : null,
                    class: "btn btn-dark-blue",
                    type: "submit"
                  }, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                          _createTextVNode(_toDisplayString(_ctx.translate("BUTTON_SUBMIT")) + " ", 1),
                          _createElementVNode("span", _hoisted_27, [
                            _createVNode(_component_inline_svg, {
                              src: "icons/duotune/arrows/arr064.svg",
                              "aria-hidden": "true"
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, [...(_cache[5] || (_cache[5] = [
                          _createTextVNode(" Please wait... ", -1),
                          _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_25)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 512))
}